import { connect, ConnectedProps } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import lang from '../../../lib/language';
import { RootState } from '../../../lib/store';

import { GoBackButton, Grid, LatestNews } from '../../../components';
import { useIsMobile } from '../../../hooks';
import { EARNINGS_CONTENT_UNLIMIT_LENGTH } from '../EarningCalendat.constants';
import Table from '../Table/Table';

import styles from './EarningsCalendarContent.module.scss';

const EarningsCalendarContent = (props: ReduxProps) => {
  const { earnings } = props;
  const { isMobile } = useIsMobile();
  const { state } = useLocation();
  const { startDate = '', endDate = '' } = (state as { startDate: string, endDate: string }) || {};

  return (
    <>
      {!isMobile && (
        <div className={styles.goBackButton}>
          <GoBackButton />
        </div>
      )}
      <Grid extraChildren={!isMobile ? <LatestNews /> : undefined}>
        <div className={classNames(styles.wrapperLayout, { [styles.wrapperLayoutMobile]: isMobile })}>
          <div className={styles.wrapperFirstSection}>
            <div className={styles.titleWrapper}>
              <h6 className={
                classNames(
                  styles.title,
                  { [styles.titleMobile]: isMobile },
                )
              }
              >
                {lang.upcomingEarnings()}
              </h6>
              {earnings.totalElements > 0 && !isMobile && (
                <div className={styles.lengthEvents}>
                  <span>{`(${earnings.totalElements} ${lang.commonDiscoverCalenderItems()})`}</span>
                </div>
              )}
            </div>
            <Table
              maxElements={EARNINGS_CONTENT_UNLIMIT_LENGTH}
              minDateState={startDate}
              maxDateState={endDate}
            />
          </div>
        </div>
      </Grid>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  earnings: state.fundamental.earningsSearchResponse,
});

const connector = connect(mapStateToProps, () => ({}));
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(EarningsCalendarContent);
